"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _preact = require("preact");
var classNames = require("classnames");
var shallowEqual = require("is-shallow-equal");
var FilePreviewAndLink = require("./FilePreviewAndLink/index.js");
var FileProgress = require("./FileProgress/index.js");
var FileInfo = require("./FileInfo/index.js");
var Buttons = require("./Buttons/index.js");
var FileItem = /*#__PURE__*/function (_preact$Component) {
  _inherits(FileItem, _preact$Component);
  var _super = _createSuper(FileItem);
  function FileItem() {
    _classCallCheck(this, FileItem);
    return _super.apply(this, arguments);
  }
  _createClass(FileItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var file = this.props.file;
      if (!file.preview) {
        this.props.handleRequestThumbnail(file);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !shallowEqual(this.props, nextProps);
    } // VirtualList mounts FileItems again and they emit `thumbnail:request`
    // Otherwise thumbnails are broken or missing after Golden Retriever restores files
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var file = this.props.file;
      if (!file.preview) {
        this.props.handleRequestThumbnail(file);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var file = this.props.file;
      if (!file.preview) {
        this.props.handleCancelThumbnail(file);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var file = this.props.file;
      var isProcessing = file.progress.preprocess || file.progress.postprocess;
      var isUploaded = file.progress.uploadComplete && !isProcessing && !file.error;
      var uploadInProgressOrComplete = file.progress.uploadStarted || isProcessing;
      var uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
      var error = file.error || false; // File that Golden Retriever was able to partly restore (only meta, not blob),
      // users still need to re-add it, so it’s a ghost

      var isGhost = file.isGhost;
      var showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;
      if (isUploaded && this.props.showRemoveButtonAfterComplete) {
        showRemoveButton = true;
      }
      var dashboardItemClass = classNames({
        'uppy-Dashboard-Item': true,
        'is-inprogress': uploadInProgress && !this.props.recoveredState,
        'is-processing': isProcessing,
        'is-complete': isUploaded,
        'is-error': !!error,
        'is-resumable': this.props.resumableUploads,
        'is-noIndividualCancellation': !this.props.individualCancellation,
        'is-ghost': isGhost
      });
      return (0, _preact.h)("div", {
        className: dashboardItemClass,
        id: "uppy_".concat(file.id),
        role: this.props.role
      }, (0, _preact.h)("div", {
        className: "uppy-Dashboard-Item-preview"
      }, (0, _preact.h)(FilePreviewAndLink, {
        file: file,
        showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
        i18n: this.props.i18n,
        toggleFileCard: this.props.toggleFileCard,
        metaFields: this.props.metaFields
      }), (0, _preact.h)(FileProgress, {
        uppy: this.props.uppy,
        file: file,
        error: error,
        isUploaded: isUploaded,
        hideRetryButton: this.props.hideRetryButton,
        hideCancelButton: this.props.hideCancelButton,
        hidePauseResumeButton: this.props.hidePauseResumeButton,
        recoveredState: this.props.recoveredState,
        showRemoveButtonAfterComplete: this.props.showRemoveButtonAfterComplete,
        resumableUploads: this.props.resumableUploads,
        individualCancellation: this.props.individualCancellation,
        i18n: this.props.i18n
      })), (0, _preact.h)("div", {
        className: "uppy-Dashboard-Item-fileInfoAndButtons"
      }, (0, _preact.h)(FileInfo, {
        file: file,
        id: this.props.id,
        acquirers: this.props.acquirers,
        containerWidth: this.props.containerWidth,
        i18n: this.props.i18n,
        toggleAddFilesPanel: this.props.toggleAddFilesPanel,
        toggleFileCard: this.props.toggleFileCard,
        metaFields: this.props.metaFields
      }), (0, _preact.h)(Buttons, {
        file: file,
        metaFields: this.props.metaFields,
        showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
        showRemoveButton: showRemoveButton,
        canEditFile: this.props.canEditFile,
        uploadInProgressOrComplete: uploadInProgressOrComplete,
        toggleFileCard: this.props.toggleFileCard,
        openFileEditor: this.props.openFileEditor,
        uppy: this.props.uppy,
        i18n: this.props.i18n
      })));
    }
  }]);
  return FileItem;
}(_preact.Component);
module.exports = FileItem;